export default __webpack_public_path__ + "static/people-careers@2x-654ce76b3ee599e2d6cbda886319b814.png";